<script>

	import './style.scss'

	import {
		URL_PREFIX,
	} from '@/constants'

	export default {
		name: 'bottom-footer',
		data: () => ({
			URL_PREFIX
		})
	}

</script>

<template>
	<footer class='footer'>
		<div class='copyright'>
			<ul>
				<li>
					<a :href='`${URL_PREFIX}`' class='copyright'>© TechInterviewClub 2018</a>
				</li>
				<li style="display:none">
					<a :href='`${URL_PREFIX}/privacy`' class='copyright'>Privacy Policy</a>
				</li>
				<li style="display:none">
					<a :href='`${URL_PREFIX}/tos`' class='copyright'>Terms of Service</a>
				</li>
				<li style="display:none">
					<a :href='`${URL_PREFIX}/press`' class='press'>Press</a>
				</li>
			</ul>
		</div>
	</footer>
</template>



// WEBPACK FOOTER //
// src/components/BottomFooter/BottomFooter.vue